import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PRODUCT } from '../../../constants/queryKeys';
import productApiV2 from '../../../lib/api/product/ProductApiV2';
import { QueryOptions } from '../../../types/query/useQuery';
import { ProductCustomFieldsResponseDto } from '../../../types/api/product-custom-fields';

type ProductCustomFieldsResponse = ProductCustomFieldsResponseDto;

type UseProductCustomFieldsArgs<SelectResultType> = {
  productId: number;
  options?: QueryOptions<ProductCustomFieldsResponse, unknown, SelectResultType>;
};

export const useProductCustomFields = <SelectResultType = ProductCustomFieldsResponse>({
  productId,
  options,
}: UseProductCustomFieldsArgs<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<ProductCustomFieldsResponse, unknown, SelectResultType>(
    [...PRODUCT.CUSTOM_FIELDS, productId],
    (): Promise<ProductCustomFieldsResponse> => productApiV2.getProductCustomFields(productId),
    {
      enabled: !!productId,
      ...options,
    },
  );
};

export default useProductCustomFields;
